/* 
If browser supports speculation api - eagerness 'eager' is used to stay between immediate 
and moderate option.
Otherwise prefetch all links for browsers that supports 'rel="prefetch"'
Note: keep links limited to avoid over speculation specially for prerender, avoid prerendering/prefetching of links that are not gonna be used.
*/
  function supportSpeculationApi() {
    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      const specScript = document.createElement('script');
      specScript.type = 'speculationrules';
      specRules = {
        prerender: [
          {
            eagerness: "eager",
            where: {
                and: [
                    {selector_matches: ".prerender_this"},
                    {not: {selector_matches: ".do_not_prerender_this"}}
                ]
            }            
          },
        ],
        prefetch: [
          {
            source: "document",
            eagerness: "eager",
            where: {
              and: [
                // link with this class will only prefetch
                {selector_matches: ".prefetch_this"},
                //links to exclude from prefetch list (for example: current active link)
                {not: {selector_matches: ".do_not_prefetch_this"}}
              ]
            }
          },
        ],
      };
      specScript.textContent = JSON.stringify(specRules);
      document.body.append(specScript);
    } else {
      //add prefetch links for browsers that doesn't supports speculation api
      const genderLinks = document.querySelectorAll('.prerender_this');
      const linksArr = document.querySelectorAll('.prefetch_this:not(.do_not_prefetch_this)');
      const combinedLinksArr = [...genderLinks, ...linksArr];
      combinedLinksArr?.forEach(link => {
        const elm = document.createElement('link');
        elm.rel = "prefetch";
        elm.as = "document";
        elm.href = link.href;
        document.head.append(elm);
      })
    }
  }

  document.addEventListener('DOMContentLoaded', supportSpeculationApi);